import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntity } from './followup.reducer';

export interface ISymptomDetailProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> { }

export const FollowupDetail = (props: ISymptomDetailProps) => {
  useEffect(() => {
    props.getEntity(props.match.params.id);
  }, []);

  const { followupEntity } = props;
  return (
    <Row>
      <Col md="8">
        <h2>
          Followup [<b>{followupEntity.id}</b>]
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="emergencyType">Followup Type</span>
          </dt>
          <dd>{followupEntity.followupType}</dd>
          <dt>
            <span id="emergencyType">Emergency Type</span>
          </dt>
          <dd>{followupEntity?.emergencyType}</dd>
          <dt>
            <span id="enCondition">Followup (English)</span>
          </dt>
          <dd>{followupEntity.enFollowup}</dd>
          <dt>
            <span id="stCondition">Followup (Sesotho)</span>
          </dt>
          <dd>{followupEntity.stFollowup}</dd>
          <dt>
            <span id="isAlive">Alive</span>
          </dt>
          <dd>{followupEntity.isAlive ? 'Yes' : 'No'}</dd>
          <dt>
            <span id="isDelivered">Delivered</span>
          </dt>
          <dd>{followupEntity.isDelivered ? 'Yes' : followupEntity.isDelivered === null ? 'Null' : 'No'}</dd>

        </dl>
        <Button tag={Link} to="/followup" replace color="info">
          <FontAwesomeIcon icon="arrow-left" /> <span className="d-none d-md-inline">Back</span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/followup/${followupEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
        </Button>
      </Col>
    </Row>
  );
};

const mapStateToProps = ({ followup }: IRootState) => ({
  followupEntity: followup.entity,
});

const mapDispatchToProps = { getEntity };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(FollowupDetail);
